import Model from '@/models/Model'

export default class WhDetailProductCriticalNotif extends Model {
    static includes = ['wh_product', 'g_branch_office']
    resource() {
        return 'wh_detail_product_critical_notif'
    }
}
